import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'

export default function HelpPage() {
  return (
    <DefaultPageLayout>
      <NextSeo
        title='利用規約'
        openGraph={{
          url: `${process.env.origin}/terms`,
          title: '利用規約 - Ambass'
        }}
      />
      <Title>利用規約</Title>
      <Container>
        <Row>
          <Description>
            この規約（以下「本利用規約」といいます。）は、September6合同会社（以下「弊社」といいます。）が運営するインターネットサービス「Ambass」において、弊社が提供する各種サービス（以下「本サービス」といいます。）の利用の諸条件を定めるものです。
          </Description>
        </Row>
        <Row>
          <Header>第1条 本サービスの内容及び弊社の役割</Header>
          <Description>
            本サービスは、コンテンツ販売プラットフォームです。ユーザー（次条で定義します。）間のデジタルコンテンツ・物品の売買の場・機会を提供するもので、ユーザー間の売買契約、販売、購入等の保証等に関しては、すべて当事者であるユーザーの自己責任とし、弊社は自ら売買を行うものではなく、売買の委託を受けるものでもありません。
          </Description>
          <Description>
            弊社は、本規約中に別段の定めがある場合を除き、売買契約の取消し、解約、解除、返品、返金、保証など取引の遂行には一切関与しません。本サービスの内容は、本利用規約に規定する通りとします。
          </Description>
        </Row>
        <Row>
          <Header>第2条 定義</Header>
          <Description>1.定義</Description>
          <Description>
            本利用規約において、以下の用語は、別途定義されている場合及び文脈上別異に解すべき場合を除き、以下の意味を有するものとします。
          </Description>
          <List>
            <ListContainer>
              「ユーザー」とは、本規約の内容に同意して、日本国内において本サービスを利用する日本在住の個人及び弊社が指定した法人を指します。
            </ListContainer>
            <ListContainer>
              「作品」とは、ユーザーが本サービスに投稿・販売する対象をいいます。なお、共通規約中の「作品情報」は、作品に関する情報も含むものとします。
            </ListContainer>
            <ListContainer>
              「クリエイター」とは、本サービスにおいて所定の手続きにより作品を販売するユーザーをいいます。
            </ListContainer>
            <ListContainer>
              「購入者」とは、本サービスにて作品を購入するユーザーをいいます。
            </ListContainer>
            <ListContainer>
              「利用料」とは、本サービスの利用に関連して、弊社がユーザーから徴収する料金（販売手数料、決済手数料その他名称の如何を問わないものとします。）をいいます。
            </ListContainer>
            <ListContainer>
              「個人情報」とは、個人情報の保護に関する法律（平成 15 年法律第 57
              号。その後の改正を含みます。）に定める「個人情報」を指すものとし、ユーザーが入力したアカウント情報（電子メールアドレス、パスワード等をいいます。）、プロフィール情報（ユーザーネームを始めとした個人に関する属性情報をいいます。）、クレジットカード情報の一部、利用履歴等で、かつ特定の個人を識別できる情報（他の情報と容易に照合することができ、それにより特定の個人を識別することとなるものを含みます。）をいいます。
            </ListContainer>
            <ListContainer>
              「販売価格」とは、クリエイターが本サービスにおいて作品を販売する際に設定する作品の価格をいいます。
            </ListContainer>
            <ListContainer>
              「売上金」とは、クリエイターが本サービスにおいて作品を販売することにより獲得した金額をいいます。
            </ListContainer>
            <ListContainer>
              「プライバシーポリシー」とは、弊社が定めるプライバシーポリシー（名称の如何を問わないものとします。）をいいます。
            </ListContainer>
            <ListContainer>
              「本規約」とは、本利用規約をいい、これらはすべて本規約を構成するものとします。
            </ListContainer>
          </List>
          <Description>2.適用</Description>
          <Description>
            本条の定義は、別途定義されている場合及び文脈上別異に解すべき場合を除き、本利用規約のほか、プライバシーポリシーにおいても、適用されるものとします。
          </Description>
        </Row>
        <Row>
          <Header>第3条 本規約への同意及び本規約の変更</Header>
          <Description>1.本規約への同意及び適用</Description>
          <Description>
            本規約は、本サービスの利用に関する条件をユーザーと弊社との間で定めることを目的とし、ユーザーと弊社の間の本サービスの利用に関わる一切の関係に適用されます。ユーザーは、本規約に同意をしたうえで、本規約の定めに従って本サービスを利用するものとし、ユーザーは、本サービスを利用することにより本規約に同意をしたものとみなされます。
          </Description>
          <Description>2.未成年者の場合</Description>
          <Description>
            ユーザーが未成年者である場合は、事前に親権者など法定代理人の包括的な同意を得たうえで本サービスを利用しなければなりません。ユーザーが未成年者である場合は、法定代理人の同意の有無に関して、弊社からユーザー又は法定代理人に対し、確認の連絡をする場合があります。
          </Description>
          <Description>3.本規約の変更</Description>
          <Description>
            弊社は、必要に応じ、弊社が運営するウェブサイト又はアプリケーション内の適宜の場所への掲示をすることにより、本規約の内容を随時変更できるものとします。本規約の変更後に、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意をしたものとみなされます。なお、本規約の変更に同意しないユーザーは、本サービスの利用を停止してください。弊社は、本規約の改定又は変更によりユーザーに生じたすべての損害について、弊社の故意又は過失に起因する場合を除き、責任を負いません。
          </Description>
        </Row>
        <Row>
          <Header>第4条 ユーザー登録及びアカウント情報</Header>
          <Description>1.登録</Description>
          <Description>
            ユーザー登録は、必ず本人が行ってください。また、ユーザー登録の際は、必ず正確な情報を入力してください。
          </Description>
          <Description>2.複数登録の禁止</Description>
          <Description>
            個人のユーザー及びユーザー登録をされようとする方（以下併せて「ユーザー等」といいます）は、複数のユーザー登録を行うことができないものとします。
          </Description>
          <Description>3.登録拒否</Description>
          <Description>
            弊社は、ユーザー登録をされようとする方が以下各号のいずれかに該当する場合、ユーザー登録の申請を承認しないことがあります。
          </Description>
          <List>
            <ListContainer>第3条第2項及び本条第2項のユーザー資格を満たしていない場合</ListContainer>
            <ListContainer>
              過去に本規約違反等により、弊社から利用停止等の処分を受けている場合
            </ListContainer>
            <ListContainer>
              登録内容に正確ではない情報又は虚偽の情報が含まれている場合
            </ListContainer>
            <ListContainer>
              弊社の運営、サービス提供若しくは他のユーザーの利用を妨害する又はそれらに支障をきたす行為を行った場合やそのおそれがあると弊社が合理的な理由に基づき判断した場合
            </ListContainer>
            <ListContainer>
              暴力団、暴力団員、暴力団員でなくなったときから5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ若しくは特殊知能暴力集団、その他これらに準ずる者（以下これらを「暴力団員等」といいます。）、テロリスト等日本政府若しくは外国政府が経済制裁の対象として指定する者に該当すること、又は暴力団員等と一定の関係を有すること（暴力団員等に対して資金を提供し若しくは便宜を供与するなどの関与をしていると認められること、暴力団員等を不当に利用していると認められること、又は、ユーザー登録をされようとする方が法人の場合、暴力団員等がその経営を支配し若しくはその法人の経営に実質的に関与していると認められること、その他暴力団員等と社会的に非難されるべき関係を有していると認められること）（以下、上記のすべてを総称して「反社会的勢力」といいます。）が判明した場合
            </ListContainer>
            <ListContainer>
              その他弊社が不適当であると合理的な理由に基づき判断する場合
            </ListContainer>
          </List>
          <Description>4.ユーザー等の確約</Description>
          <Description>
            ユーザー等は、反社会的勢力のいずれにも該当しないこと、かつ将来にわたっても該当しないこと、及び、自ら又は第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、取引に関して脅迫的な言動をし又は暴力を用いる行為、風説を流布し、偽計を用い又は威力を用いて弊社の信用を毀損し又は弊社の業務を妨害する行為、その他これらに準ずる行為を行わないことを確約するものとします。
          </Description>
          <Description>5.登録内容の変更</Description>
          <Description>
            ユーザーは、登録内容に変更がある場合は、直ちに変更しなければならず、常にユーザー自身の正確な情報が登録されているように登録内容を管理及び修正する責任を負います。登録内容に変更があったにもかかわらず変更を行っていない場合、弊社は、登録内容に変更がないものとして取り扱うことができます。変更の届出があった場合でも、変更登録前に行われた取引や各種手続は、変更前の情報に依拠する場合があります。
          </Description>
          <Description>6.アカウント情報の管理</Description>
          <Description>
            ユーザーは、入力したメールアドレス、パスワード等の情報（以下「アカウント情報」といいます。）を自ら管理する責任を負います。ユーザーは、アカウント情報を第三者に利用させることや、譲渡、売買、質入、貸与、賃貸その他形態を問わず処分することはできません。
          </Description>
          <Description>7.アカウント情報の不正利用等</Description>
          <Description>
            アカウント情報の管理不十分による情報の漏洩、使用上の過誤、第三者の使用、不正アクセス等による損害の責任はユーザーが負うものとし、弊社の故意又は過失に起因する場合を除き、弊社は責任を負わないものとします。また、アカウント情報が不正に利用されたことにより弊社に損害が生じた場合、ユーザーは当該損害を賠償するものとします。
          </Description>
          <Description>8.アカウント情報の漏えい</Description>
          <Description>
            ユーザーは、アカウント情報が第三者に漏えいした場合又はそのおそれがある場合、速やかに弊社まで連絡するものとします。また、その際に弊社の指示がある場合にはこれに従うものとします。
          </Description>
        </Row>
        <Row>
          <Header>第5条 ユーザー登録の取消等</Header>
          <Description>1.ユーザー登録の取消・利用停止等</Description>
          <Description>
            弊社は、ユーザーが以下の各号のいずれかに該当した場合又は該当したと弊社が合理的な理由に基づき判断した場合、事前の通知なしに、ユーザー登録の取消、本サービスの全部若しくは一部へのアクセスの拒否、利用停止等、又は、ユーザーに関連するコンテンツや情報の全部若しくは一部の削除の措置をとることができるものとし、弊社は、その理由を説明する義務を負わないものとします。
          </Description>
          <Description>
            なお、弊社は、ユーザーが以下の各号のいずれにも該当しないことを確認するために、弊社が必要と判断する本人確認を行うことができ、かかる本人確認が完了するまで本サービスの全部又は一部へのアクセスの拒否、利用停止等の措置をとることができます。
          </Description>
          <List>
            <ListContainer>法令又は本規約に違反した場合</ListContainer>
            <ListContainer>不正行為があった場合</ListContainer>
            <ListContainer>登録した情報が虚偽の情報であると弊社が判断した場合</ListContainer>
            <ListContainer>本規約上必要となる手続又は弊社への連絡を行わなかった場合</ListContainer>
            <ListContainer>登録した情報が既存の登録と重複している場合</ListContainer>
            <ListContainer>
              登録した携帯電話番号又はメールアドレスが不通になったことが判明した場合
            </ListContainer>
            <ListContainer>
              ユーザーが債務超過、無資力、支払停止又は支払不能の状態に陥った場合
            </ListContainer>
            <ListContainer>他のユーザーや第三者に不当に迷惑をかけた場合</ListContainer>
            <ListContainer>
              ユーザーが登録した金融機関の口座に関し違法、不適切その他の問題があることが当該金融機関による指摘等により判明した場合
            </ListContainer>
            <ListContainer>第4条第3項各号のいずれかに該当する場合</ListContainer>
            <ListContainer>
              ユーザーが自ら又は第三者をして、暴力的な要求行為、法的な責任を超えた不当な要求行為、脅迫的な言動若しくは暴力を用いる行為、又は風評を流布し、偽計を用い若しくは威力を用いて、信用を毀損若しくは業務を妨害する行為をした場
            </ListContainer>
            <ListContainer>その他弊社がユーザーに相応しくないと判断した場合</ListContainer>
          </List>
          <Description>2.サービスの利用禁止等</Description>
          <Description>
            弊社は、本条の措置を受けたユーザーに対し、将来にわたって弊社が提供するサービスの利用及びアクセスを禁止することができるものとします。
          </Description>
          <Description>3.弊社の免責</Description>
          <Description>
            弊社は、本条の措置により生じる損害について、弊社の故意又は過失に起因する場合を除き、責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第6条 ユーザーの退会</Header>
          <Description>
            ユーザーは所定の手続きを行うことより、本サービスを退会することができます。ただし、以下各号のいずれかに該当する場合、退会の手続きを行うことはできません。本サービス内でそれぞれの該当事由を抹消した後に、退会処理を行ってください。
          </Description>
          <List>
            <ListContainer>払込処理の終わっていない振込申請がある場合</ListContainer>
            <ListContainer>受取可能な布教リンクを所有している場合</ListContainer>
          </List>
          <Description>2.弊社の免責</Description>
          <Description>
            弊社は、本条の措置により生じる損害について、弊社の故意又は過失に起因する場合を除き、責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第7条 個人情報等の取扱い</Header>
          <Description>1.プライバシーポリシー</Description>
          <Description>
            弊社は、本規約のほか、プライバシーポリシーに従って個人情報等を取り扱います。
          </Description>
          <Description>2.プライバシーポリシーへの同意</Description>
          <Description>
            ユーザーは、本サービスの利用又は本サービスの閲覧の前に、本サービス上で、プライバシーポリシーを必ず確認し、その内容に同意した上で、本サービスを利用するものとします。
          </Description>
        </Row>
        <Row>
          <Header>第8条 禁止事項</Header>
          <Description>
            ユーザーは、本サービスの利用にあたり、以下の各号に該当する事項を行ってはならないものとします。
          </Description>
          <List>
            <ListContainer>
              弊社もしくは第三者の著作権、意匠権その他の知的財産権（第16条にて定義します。）、その他の権利を侵害する行為、または侵害するおそれのある行為
            </ListContainer>
            <ListContainer>
              本サービスおよび個別サービスに投稿等されている投稿情報を、当該著作者（創作者）の同意なくして転載する行為
            </ListContainer>
            <ListContainer>
              本サービスもしくは本サービスの一部（コンテンツ・情報・機能・システム・プログラム等）を使用・転用・転売・複製・送信・翻訳・翻案・改変などして、いかなる手法を問わず商業・営業目的の活動、営利を目的とした利用およびその準備を目的とした利用をすること、その他本サービスの2次利用や複製行為。但し、ユーザー本人による投稿情報は除きます。
            </ListContainer>
            <ListContainer>
              弊社もしくは第三者の財産、肖像権などプライバシーを侵害する行為、または侵害するおそれのある行為
            </ListContainer>
            <ListContainer>
              弊社もしくは第三者を不当に差別もしくは誹謗中傷し、第三者への不当な差別を助長し、またはその名誉もしくは信用を毀損する行為
            </ListContainer>
            <ListContainer>
              ストーカー行為等の規制等に関する法律に違反する行為、大量または長時間の架電、同様の問い合わせの繰り返しを過度に行う行為、メッセージ機能により大量のメッセージを送信する行為、義務や理由のないことを強要する行為
            </ListContainer>
            <ListContainer>詐称行為</ListContainer>
            <ListContainer>
              詐欺その他の犯罪に結びつく、または結びつくおそれのある行為
            </ListContainer>
            <ListContainer>
              法令その他弊社が定める基準に反するような、過度な残酷表現またはわいせつ、児童ポルノ若しくは児童虐待に相当する投稿情報のデータ（以下「これらのデータ」といいます。）について、次に掲げるいずれかの行為を行うこと
              <List>
                <NestListContainer>
                  これらのデータを発信、投稿、編集または表示する行為
                </NestListContainer>
                <NestListContainer>これらのデータを収録した媒体を販売する行為</NestListContainer>
                <NestListContainer>
                  これらのデータを収録した媒体の送信、表示、販売を想起させる広告を投稿または表示する行為
                </NestListContainer>
              </List>
            </ListContainer>
            <ListContainer>
              自殺・自傷行為・薬物乱用などを美化・誘発・助長するおそれのある行為
            </ListContainer>
            <ListContainer>
              次に掲げる内容の投稿情報のデータを投稿等する行為
              <List>
                <NestListContainer>
                  投稿等されている投稿情報を誹謗中傷する内容の情報
                </NestListContainer>
                <NestListContainer>
                  投稿者または第三者（弊社従業員等を含む。）の氏名、住所、勤務先、電話番号等個人を特定しうる内容の情報（投稿等された投稿情報と照らし合わせることで個人を特定しうる場合を含む。）
                </NestListContainer>
                <NestListContainer>
                  真否についての事実確認が困難な内容や虚偽の内容の情報
                </NestListContainer>
                <NestListContainer>その他弊社が不適切と判断する内容の情報</NestListContainer>
              </List>
            </ListContainer>
            <ListContainer>運営者または第三者に成りすます行為</ListContainer>
            <ListContainer>
              弊社が定める方法以外の方法で、本サービスの利用権を、現金、財物その他の経済上の利益と交換する行為
            </ListContainer>
            <ListContainer>同種のアカウントを複数取得する行為</ListContainer>
            <ListContainer>
              商業用の広告、宣伝または勧誘を目的とする投稿情報（弊社が特に認めたものを除く。）、アフィリエイトのリンクを含む投稿情報、MLM・リードメール等他人を勧誘する内容の投稿情報、アダルトサイト・ワンクリック詐欺サイト・ウィルス等の有害なコンピュータプログラム等を流布させることを目的とするサイト等弊社が不適切と判断するサイトに誘導する投稿情報（単にリンクを張る行為を含む。）、その他弊社が不適切と判断する投稿情報を投稿等する行為
            </ListContainer>
            <ListContainer>
              弊社からの、またはユーザー間取引を行っている他のユーザーからの連絡に対する不当な応答の遅延や無視を行う行為
            </ListContainer>
            <ListContainer>
              企業などからなんらかの見返りを受け取ったにも関わらず、第三者を装って行う宣伝など（以下、「ステルスマーケティング」）に該当する行為、または本サービスをステルスマーケティング等に利用する行為
            </ListContainer>
            <ListContainer>
              人種・民族・性別・年齢・思想などによる差別に繋がる表現を使用する行為
            </ListContainer>
            <ListContainer>
              通常の範囲を超えて本サービスのサーバーに負担をかける行為、もしくは、本サービスの運営やネットワーク・システムに支障を与える行為、またはこれらのおそれのある行為
            </ListContainer>
            <ListContainer>
              弊社の設備に蓄積された情報を不正に書き換え、または消去する行為
            </ListContainer>
            <ListContainer>
              ウィルス等の有害なコンピュータプログラム等を送信または掲載する行為
            </ListContainer>
            <ListContainer>
              日本国内外の法令、公序良俗、本規約または個別規約等に違反し、または他者の権利を侵害すると弊社が判断する行為
            </ListContainer>
            <ListContainer>
              極端な思想や反社会的行為を賛美・助長する表現を投稿または編集する行為
            </ListContainer>
            <ListContainer>
              人種、信条、職業、性別、宗教などの差別を賛美・助長する表現を投稿または編集する行為
            </ListContainer>
            <ListContainer>
              カルト的宗教活動、過度な政治活動を賛美・助長する表現を投稿または編集する行為
            </ListContainer>
            <ListContainer>
              本サービスを利用して以下の作品の販売・購入・登録等の取引を行う行為
              <List>
                <NestListContainer>
                  覚せい剤、麻薬、向精神薬、大麻、あへん、毒物、劇物等の禁制品
                </NestListContainer>
                <NestListContainer>
                  大麻種子、合法ドラッグ（脱法ドラッグ）に関連する商品
                </NestListContainer>
                <NestListContainer>銃砲、刀剣類、武器、火薬類、化学兵器</NestListContainer>
                <NestListContainer>
                  法律・条例・その他弊社が定める基準に反するような、わいせつ、児童ポルノまたは児童虐待に相当する画像等のデータを含む商品等
                </NestListContainer>
                <NestListContainer>
                  修正のない性器の露骨な描写や結合部分の具体的描写等がある商品
                </NestListContainer>
                <NestListContainer>使用済み下着、制服等</NestListContainer>
                <NestListContainer>売春、児童売春</NestListContainer>
                <NestListContainer>賭博、富くじに関連する商品等</NestListContainer>
                <NestListContainer>無限連鎖講、マルチ商法に関連する商品</NestListContainer>
                <NestListContainer>たばこ</NestListContainer>
                <NestListContainer>
                  偽造された通貨、公正証書（免許証、旅券等含む）、会員権、文書、電磁的記録等の商品
                </NestListContainer>
                <NestListContainer>銀行口座等</NestListContainer>
                <NestListContainer>
                  商品券、プリペイドカード、印紙、切手、回数券、その他の有価証券等の金券類
                </NestListContainer>
                <NestListContainer>
                  偽ブランド品、模造品・海賊版（違法コピー商品等）
                </NestListContainer>
                <NestListContainer>
                  マジコン、パンドラバッテリー等の違法コピーを助長させる機器または関連商品
                </NestListContainer>
                <NestListContainer>
                  窃盗、強盗、詐欺、恐喝、横領、背任その他犯罪により入手した商品
                </NestListContainer>
                <NestListContainer>
                  エアガン、スタンガン、催涙スプレー、法令により携行を禁止された刃物、盗聴器、超小型カメラ、赤外線カメラ等犯罪に使用されるおそれがある商品
                </NestListContainer>
                <NestListContainer>
                  特許権、実用新案権、意匠権、商標権、著作権、等第三者の知的財産権（第16条に定義する。）や他者のプライバシーを侵害する商品等
                </NestListContainer>
                <NestListContainer>
                  クリエイターが創作に関与していないなど（但し、創作者から著作権等の権利を譲り受けた場合などを含みません。）、商品の販売等についての権利を有しない商品
                </NestListContainer>
                <NestListContainer>
                  具体的な創作物を伴わないサービス提供、およびそのおそれのある商品
                </NestListContainer>
                <NestListContainer>
                  コンピューターウィルスなどセキュリティ上の脅威を含むソフトウェア
                </NestListContainer>
                <NestListContainer>
                  身体機能検査キット、医療機器（医療用具）、医薬品、また国内で販売が禁止されている医薬品
                </NestListContainer>
                <NestListContainer>人体および人体の一部</NestListContainer>
                <NestListContainer>動物の生体および生体の一部、昆虫等の生物</NestListContainer>
                <NestListContainer>
                  個人情報、営業秘密その他一般に公開されていない情報
                </NestListContainer>
                <NestListContainer>
                  販売に際して法律で義務付けられている免許、資格条件を満たしていない商品
                </NestListContainer>
                <NestListContainer>
                  その他取引することが法令（特定商取引に関する法律、銃刀法、麻薬、ワシントン条約、その他関連条約等）に違反する商品
                </NestListContainer>
                <NestListContainer>クレジットカード利用枠の現金化目的の商品</NestListContainer>
                <NestListContainer>役務提供期間が長期にわたる商品</NestListContainer>
                <NestListContainer>
                  販売にあたり許認可・登録・届出等が必要となる商品
                </NestListContainer>
                <NestListContainer>
                  FX、株、仮想通貨など金融に関する情報商材、それに伴うツール及び関連商品
                </NestListContainer>
                <NestListContainer>
                  その他、弊社の禁止事項・利用規約範囲外で、弊社が適切ではないと判断した商品
                </NestListContainer>
              </List>
            </ListContainer>
            <ListContainer>
              ユーザーが本サービスを利用して他のユーザーに対する商品、権利又は役務の提供主体となる場合において、現金払いの場合とクレジットカード決済の場合とで異なる代金を請求するなど、本サービスの他のユーザーにとって不利になる行為。
            </ListContainer>
            <ListContainer>その他、弊社が不適切と判断する行為。</ListContainer>
          </List>
        </Row>
        <Row>
          <Header>第9条 クリエイターの加盟店契約</Header>
          <Description>1.加盟店契約の申込み</Description>
          <Description>
            クリエイターは、本サービスにて自らの作品を出品することにより、本条の加盟店契約（以下「本加盟店契約」といいます。）の申し込みを行ったものとみなされることに同意します。
          </Description>
          <Description>2.加盟店契約の成立</Description>
          <Description>
            本加盟店契約は、弊社がクリエイターの作品の出品を承認をした時点で、弊社及びクリエイターとの間で成立するものとします。
          </Description>
          <Description>3.加盟店契約の不成立</Description>
          <Description>
            前項に定める加盟店契約が成立しなかった場合、クリエイターは、本サービスにおける出品を行うことができないものとします。なお、弊社は、第1項に定める申込みに対し、加盟店として承認しなかった場合でも、クリエイターに対し、その理由を開示する義務を負わないものとします。
          </Description>
          <Description>4.代理受領権限の付与</Description>
          <Description>
            クリエイターは、弊社に対し、ユーザー、本サービス上での決済等に係るクレジットカード会社、決済事業者又は収納代行業者から支払われる販売代金につき、代理受領権限を付与します。
          </Description>
          <Description>5.代理受領権限の付与への同意</Description>
          <Description>
            クリエイターは、弊社が、必要に応じて、決済事業者及び収納代行業者に対し、商品代金を代理受領する権限を付与することに同意するものとします。
          </Description>
        </Row>
        <Row>
          <Header>第10条 作品の販売</Header>
          <Description>1.販売手続等</Description>
          <Description>
            クリエイターは、弊社所定の手続に従い作品の販売を行うものとします。
          </Description>
          <Description>2.販売価格</Description>
          <Description>
            クリエイターが出品する作品の価格は、がクリエイターが自由に決定することができるものとします。ユーザー同士が取引する金額や本個別サービスの利用料金については、すべて消費税が含まれるものとします。
          </Description>
          <Description>3.販売禁止物</Description>
          <Description>
            クリエイターは第8条にて販売が禁止されている作品（以下「販売禁止物」といいます。）に記載された作品の販売ができないことについて、予め了承します。販売禁止物に該当する作品を販売した場合は、クリエイターの故意又は過失に関わらず、本規約違反行為とみなします。
          </Description>
          <Description>4.作品の説明等</Description>
          <Description>
            クリエイターは、作品を販売する際に、真に売却する意思のない作品、その作品情報だけでは正しく作品を理解できない又は混乱する可能性のある販売、作品の説明で十分な説明を行わない販売等を行ってはなりません。また、クリエイターは、販売する作品と関係のない画像等を当該作品情報として掲載してはいけません。
          </Description>
          <Description>5.法令遵守</Description>
          <Description>
            クリエイターは、販売にあたっては、古物営業法、特定商取引に関する法律、不当景品類及び不当表示防止法、不正競争防止法、商標法、著作権法その他の法令を遵守しなければなりません。
          </Description>
          <Description>6.販売に関する本規約違反</Description>
          <Description>
            販売に関して、弊社が本規約又は加盟店契約等に違反する又は不適切であると合理的な理由に基づき判断した場合、弊社は、関連する作品情報について、その全部もしくは一部の削除または公開範囲の変更等の措置を行うことができるものとします。
          </Description>
          <Description>
            また、第5条に定める措置のほか、その販売に対して発生していた購入行為等を弊社の判断で取消すことができるものとします。本項に基づく措置によってユーザーに生じる損害について、弊社の故意又は過失に起因する場合を除き、弊社は責任を負わないものとします。
          </Description>
          <Description>7.弊社の免責</Description>
          <Description>
            クリエイターの販売等によって、クリエイター及び第三者に生じる損害につき、弊社の故意又は過失に起因する場合を除き、弊社は責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第11条 作品の購入</Header>
          <Description>1.購入手続</Description>
          <Description>
            ユーザーは、弊社の定める手続により購入の意思をもって、注文を行うものとします。
          </Description>
          <Description>2.購入意思等</Description>
          <Description>
            ユーザーは、購入する意思のない注文、転売等の営利を目的とした作品の購入等、及び弊社の判断でいたずら目的と見受けられる注文を行うことはできません。
          </Description>
          <Description>3.必要データ</Description>
          <Description>
            弊社が定める取引開始可能な時間内に、弊社の管理するサーバーに作品購入に関するデータ、販売意思のアクションデータなどの弊社所定のデータの到達が確認できなかった場合、注文は無効になるものとし、ユーザーは予めこれを承諾するものとします。
          </Description>
          <Description>4.自らの作品の購入禁止等</Description>
          <Description>
            クリエイターは、自らの作品を購入することはできません。作品の販売を取り下げたい場合は、ユーザーは、弊社所定の手続に従って行うものとします。
          </Description>
          <Description>5.弊社の免責</Description>
          <Description>
            ユーザーの注文、購入等によって、ユーザー及び第三者に生じる損害につき、弊社の故意又は過失に起因する場合を除き、弊社は責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第12条 支払及び取引の実行</Header>
          <Description>1.売買契約の成立</Description>
          <Description>
            購入者が販売された特定の作品の購入完了手続をした時をもって当該作品の売買契約が成立するものとします。クリエイター及び購入者は、売買契約に基づき発生した権利義務を第三者に譲渡、担保提供その他の処分することはできないものとします。
          </Description>
          <Description>2.支払期限</Description>
          <Description>
            売買契約が成立した場合、購入者は、弊社の定める方法により作品代金と利用料の合計額を支払うものとします。
          </Description>
          <Description>3.作品等に関するトラブル</Description>
          <Description>
            クリエイター及び購入者の間で作品等に関してトラブルが発生した場合は当該ユーザー間で解決するものとします。但し、弊社の判断により、弊社も協議に入ることができるものとします。
          </Description>
          <Description>4.キャンセル及び作品の瑕疵</Description>
          <Description>
            本サービスの利用にあたり、クリエイター及び購入者間の合意がある場合を除き、作品の注文後のキャンセルはできないものとします。作品に瑕疵がある場合、作品の説明と実際の作品が明らかに異なる場合はクリエイターが責任を負うものとし、クリエイターの責任により、作品交換等の対応を行うものとします。
          </Description>
          <Description>5.支払手続</Description>
          <Description>
            支払又は決済が本サービスに関して必要となる場合、本サービスのオンラインシステムを通じて行われるものとし、その詳細は本サービス中の所定の手続きに従うものとします。なお、本サービス利用に関し、弊社はユーザーに対して作品の売主又は役務の提供者となるわけではないため、ユーザーによって支払われた代金についての領収書等をユーザーに対して発行するものではありません。送金手数料など、支払いに必要な費用についてはユーザーの負担となります。
          </Description>
          <Description>6.不払・支払遅延等</Description>
          <Description>
            ユーザーが本規約に従って必要な支払いを行わない場合、本サービスに入力したクレジットカードの利用が停止された場合には、弊社は当該ユーザーに通知することなく、当該ユーザーによる本サービスの利用を停止することができるほか、第5条に定める措置をとることができるものとします。
          </Description>
          <Description>7.弊社の免責</Description>
          <Description>
            ユーザーが本サービスに入力した決済手段又は金融機関の情報が第三者に利用されたこと若しくは入力情報の内容が不正確であったこと又は弊社が本条に基づく措置を行ったこと若しくは行わなかったことによってユーザーに生じた損害に関して、弊社の故意又は過失に起因する場合を除き、弊社は責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第13条 利用料</Header>
          <Description>1.利用料の支払い</Description>
          <Description>
            クリエイターは、弊社に対し、販売した作品の売買契約が成立した場合、本サービスにつき弊社が受領する販売手数料および弊社が決済代行事業者への支払金額相当額分として、売買契約が成立した作品の販売価格に弊社が定める料率を乗じた金額を利用料として支払うものとします。
          </Description>
          <Description>2.利用料の徴収方法への同意</Description>
          <Description>
            本サービスの利用料は、弊社及びクリエイターとの間の加盟店契約に従って、弊社がクリエイターに代理して購入者から受領する作品代金相当額から差し引く方法により徴収されるものとし、クリエイターは、かかる方法により徴収することにつき予め同意するものとします。
          </Description>
          <Description>3.利用料の改訂</Description>
          <Description>
            弊社は、ユーザーの承諾を得ることなく利用料等の料金を改定する場合があり、ユーザーはこれに同意することとします。また、改定後の料金体系は、契約更新時に適用されるものとします。
          </Description>
        </Row>
        <Row>
          <Header>第14条 クリエイターへの売上の支払い</Header>
          <Description>1.弊社からクリエイターへの売上の支払方法</Description>
          <Description>
            弊社はクリエイターがサービス上で弊社が指定する方法に従った振込申請を行った場合、クリエイターの売上金額から利用料等を差し引いた金額（以下「受取金額」といい、受取金額には売り上げた商品代金の消費税相当額が含まれるものとします。）を計算し、受取金額から振込手数料を差し引いて、送金いたします。
          </Description>
          <Description>2.振込申請がない場合の処理</Description>
          <Description>
            半年間振込申請がない場合は、当該受取金額の振込は、最後に弊社からクリエイターへの振込みがあった月から半年が経過した期日の翌月20日から5営業日以内に振込むものとします。
          </Description>
          <Description>3.振込手数料</Description>
          <Description>
            振込手数料は1回の振込申請につき、300円とします。当該受取金額が振込手数料を下回る場合は、弊社からクリエイターに対しての支払いは発生しないものとします。
          </Description>
          <Description>4.振込手数料の変更</Description>
          <Description>
            振込手数料の料率は適用法令に定める手続に従うことにより、任意の理由により、変更できるものとします。料率を変更する場合においては、弊社が適当と判断する方法で、可能な限り事前にユーザーにその旨を通知し、または公表するものとします。
          </Description>
          <Description>5.振込先誤登録時等の処理</Description>
          <Description>
            クリエイター振込先の不備・誤登録等により振込が行えなかった場合、振込ができなかった旨の連絡をしたのち、申請手続きを取り下げさせていただきます。
          </Description>
          <Description>6.過払い時の処理</Description>
          <Description>
            弊社のシステムの不具合その他の理由により、クリエイターへ振り込むべき金額を過払いした場合には、クリエイターは、理由のいかんにかかわらず、過払いに係る代金を弊社に対して直ちに返還する義務を負うものとします。
          </Description>
          <Description>7.振込の停止</Description>
          <Description>
            弊社は、クリエイターの販売する作品の権利関係等に疑義が生じた場合やユーザーからの問い合わせ等によりクリエイター・ユーザー間に発生したトラブルについて一定期間後も解決されていないと判断した場合には、当該クリエイターへの受取金額の振込を停止できるものとし、クリエイターはこれを承諾するものとします。
          </Description>
          <Description>8.支払義務の免除</Description>
          <Description>
            一定期間振込申請手続きがされなかった、または振込先情報の不備等により振込みが行えなかった等の場合、売り上げた日から6か月経過した時点で、弊社は、当該クリエイターが、弊社の当該受取金額についての支払義務を免除したものとみなします。
          </Description>
          <Description>
            また、クリエイターが退会し、かつ未払い受取金額が存在する場合であっても、弊社は、当該クリエイターが、弊社の当該受取金額についての支払義務を免除したものとみなします。
          </Description>
          <Description>9.支払債務の消滅</Description>
          <Description>
            弊社および弊社が指定する第三者がユーザーから商品代金等を受領することにより、商品等契約に基づくユーザーの商品代金の支払債務は消滅するものとします。
          </Description>
        </Row>
        <Row>
          <Header>第15条 他のサービスへの遷移</Header>
          <Description>
            ユーザーが本サービスを利用するにあたり、本サービスから、第三者が運営する他のサービス（以下「外部サービス」といいます。）に遷移する場合があります。ユーザーは、予めこれに同意するものとし、本規約及び外部サービスの利用規約等を遵守して、本サービス及び外部サービスを利用するものとします。なお弊社は、外部サービスについて保証しません。
          </Description>
        </Row>
        <Row>
          <Header>第16条 本サービスの中断・終了及び変更</Header>
          <Description>1.本サービスの中断</Description>
          <Description>
            弊社は、以下の各号のいずれかに該当する場合には、ユーザーに事前に通知することなく一時的に本サービスの全部又は一部を中断する事ができるものとします。
          </Description>
          <List>
            <ListContainer>
              サーバー、通信回線、その他の設備の故障、障害の発生又はその他の理由により本サービスの提供ができなくなった場合
            </ListContainer>
            <ListContainer>
              定期的な又は緊急のシステム（サーバー、通信回線や電源、それらを収容する建築物などを含む）の保守、点検、修理、変更を行う場合
            </ListContainer>
            <ListContainer>火災、停電等により本サービスの提供ができなくなった場合</ListContainer>
            <ListContainer>
              地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合
            </ListContainer>
            <ListContainer>
              戦争、変乱、暴動、騒乱、労働争議等その他不可抗力により本サービスの提供ができなくなった場合
            </ListContainer>
            <ListContainer>
              法令又はこれに基づく措置により本サービスの提供ができなくなった場合
            </ListContainer>
            <ListContainer>その他運用上又は技術上、弊社が必要と判断した場合</ListContainer>
          </List>
          <Description>2.本サービスの終了及び変更</Description>
          <Description>
            弊社は、適用法令に定める手続に従うことにより、任意の理由により、本サービスの全部又は一部を終了及び変更できるものとします。本サービスを終了する場合においては、弊社が適当と判断する方法で、可能な限り事前にユーザーにその旨を通知し、または公表するものとします。
          </Description>
        </Row>
        <Row>
          <Header>第17条 知的財産権及びコンテンツ</Header>
          <Description>1.知的財産権等の帰属</Description>
          <Description>
            本サービスを構成するすべての素材に関する権利は、弊社又は当該権利を有する第三者に帰属しています。ユーザーは、本サービスのすべての素材に関して、一切の権利を取得することはないものとし、権利者の許可なく、所有権、著作権を含む一切の知的財産権、肖像権、パブリシティー権等、コンテンツ素材に関する権利を侵害する一切の行為をしてはならないものとします。本規約に基づく本サービスの利用の許諾は、本サービスに関する弊社又は当該権利を有する第三者の権利の使用許諾を意味するものではありません。
          </Description>
          <Description>2.弊社による利用</Description>
          <Description>
            クリエイターにより投稿された写真、作品情報等に関しては、本サービスの宣伝、運営、研究開発及び発表等を目的として、弊社及び弊社の指定する者が自由に利用できるものとします。
          </Description>
          <Description>3.コンテンツに関する責任</Description>
          <Description>
            ユーザー等が本サービスに関連して発信又は掲載したコンテンツに関する一切の責任は、当該ユーザー等が負うものとし、弊社は、その内容、品質、正確性、信憑性、適法性、最新性、有用性等について、確認いたしません。また、弊社は、それらに関して保証しないものとします。
          </Description>
          <Description>4.コンテンツの内容等</Description>
          <Description>
            ユーザー等は、他のユーザー等が発信又は掲載するコンテンツについて、その内容、品質、正確性、信憑性、適法性、最新性、有用性等を、ユーザー等ご自身で判断する必要があります。弊社は、ユーザー等及び第三者が弊社のコンテンツを利用することにより生じる損害について、弊社の故意又は過失に起因する場合を除き、責任を負わないものとします。
          </Description>
          <Description>5.バックアップ</Description>
          <Description>
            弊社はコンテンツのバックアップを行う義務を負わないものとします。ユーザーは、コンテンツのバックアップが必要な場合には、自己の費用と責任でこれを行うものとします。
          </Description>
          <Description>6.コンテンツの変更及び削除</Description>
          <Description>
            弊社は、ユーザーが本規約に違反又は本規約の精神に照らして不適切な行為を行ったと弊社が判断した場合、当該ユーザーが掲載したあらゆるコンテンツを、事前の通知なしに変更及び削除できるものとします。
          </Description>
        </Row>
        <Row>
          <Header>第18条 ユーザーの責任及び接続環境等</Header>
          <Description>1.必要な機器の準備等</Description>
          <Description>
            本サービスの提供を受けるために必要なコンピューター、スマートフォンその他の機器、ソフトウェア、通信回線その他の通信環境等は、ユーザーの費用と責任において準備し維持するものとします。また、その機器、ソフトウェア、通信環境等の設置や操作についても、ユーザーの費用と責任で行っていただく必要があります。弊社は、本サービスがあらゆる機器等に適合することを保証するものではなく、機器等の準備、設置、操作に関し、一切関与せず、ユーザーに対するサポートも行いません。
          </Description>
          <Description>2.ネットワークの経由等</Description>
          <Description>
            ユーザーは、本サービスを利用する際に、種々のネットワークを経由する場合があることを理解し、接続しているネットワークや機器等によっては、それらに接続したり、それらを通過するために、データや信号等の内容が変更される可能性があることを理解したうえで、本サービスを利用するものとします。
          </Description>
          <Description>3.手続の成立</Description>
          <Description>
            ユーザーがインターネット回線を通じて行う本サービスへの入力、販売、購入、退会、その他の手続は、弊社のサーバーに当該手続に関するデータが送信され、弊社のシステムに当該手続の内容が反映された時点をもって有効に成立するものとします。
          </Description>
          <Description>4.トラブルの解決</Description>
          <Description>
            本サービスに関連してユーザー間又はユーザーと第三者間で発生したトラブル（本サービスを将来利用するという前提の下で起こったトラブルを含みます。）に関して、ユーザーは各自の費用及び責任で解決するものとします。トラブルが生じた際には、当事者間で解決するものとし、当該トラブルにより弊社が損害を被った場合は、当事者は連帯して当該損害を賠償するものとします。
          </Description>
          <Description>5.第三者との紛争解決</Description>
          <Description>
            ユーザーと第三者との間で、本サービスに関連して、裁判、クレーム、請求等のあらゆるトラブルを含む紛争が生じた場合、ユーザー各自の責任や費用で解決するものとし、弊社は、当該紛争に一切関与しません。当該紛争がユーザーの故意又は過失に起因して生じた場合には、ユーザーは、当該紛争により弊社に生じた損害を連帯して賠償するものとします。
          </Description>
          <Description>6.費用の負担</Description>
          <Description>
            弊社とユーザー間で紛争が生じた場合において、当該紛争がユーザーの故意又は過失に起因して生じた場合には、ユーザーは当該紛争に関連して弊社に発生した損害を賠償するものとします。
          </Description>
        </Row>
        <Row>
          <Header>第19条 非保証及び免責</Header>
          <Description>1.内容等に関する非保証</Description>
          <Description>
            弊社は、本サービスの内容、品質及び水準並びに本サービスの安定的な提供、本サービスの利用に伴う結果等については、保証しません。
          </Description>
          <Description>2.弊社の免責</Description>
          <Description>
            本サービス提供における、不正確、不適切又は不明瞭な内容、表現、行為等により、ユーザー及び第三者に対して損害が生じた場合、弊社の故意又は過失に起因する場合を除き、弊社は、当該損害について責任を負わないものとします。
          </Description>
          <Description>3.情報提供に関する非保証</Description>
          <Description>
            弊社は、本サービスに関連して、ユーザー等に対して、適宜情報提供を行うことがありますが、当該情報の正確性や有用性を保証するものではありません。
          </Description>
          <Description>4.コンピュータウィルス等に関する非保証</Description>
          <Description>
            本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていないことに関して、保証しません。弊社は、本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていたことにより生じた損害について、ユーザー及び第三者に対して、弊社の故意又は過失に起因する場合を除き、責任を負わないものとします。
          </Description>
        </Row>
        <Row>
          <Header>第20条 損害賠償</Header>
          <Description>1.ユーザーの責任</Description>
          <Description>
            ユーザーが本規約に違反した場合、当該ユーザーが、当該違反により損害を受けたユーザー及び第三者に対する損害賠償責任を含む、一切の責任を負うものとします。ユーザーがかかる違反行為を行ったことにより、弊社が損害を被った場合は、当該ユーザーその他関連当事者は連帯して当該損害を賠償するものとします。
          </Description>
          <Description>2.弊社の免責</Description>
          <Description>
            弊社は、弊社による本サービスの提供の停止、終了又は変更、ユーザー登録の取消、コンテンツの削除又は消失､本サービスの利用によるデータの消失又は機器の故障その他本サービスに関連してユーザーが被った損害につき、弊社の故意又は過失に起因する場合を除き、賠償する責任を負わないものとします。
          </Description>
          <Description>3.弊社の責任の範囲</Description>
          <Description>
            弊社がユーザーに対して損害賠償責任を負う場合においても、弊社の責任は、弊社の債務不履行又は不法行為によりユーザーに生じた損害のうち現実に発生した直接かつ通常の損害に限るものとします。但し、弊社の故意又は重過失に起因する場合を除きます。
          </Description>
        </Row>
        <Row>
          <Header>第21条 一般条項</Header>
          <Description>1.通知</Description>
          <Description>
            本サービスに関する弊社からユーザーへの通知又は連絡は、弊社が運営するウェブサイト又はアプリケーション内の適宜の場所への掲示その他、弊社が適当と判断する方法により行なうものとします。弊社は、個々のユーザーに通知及び連絡をする必要があると判断した際、登録された電子メールアドレスに対し、メッセージング機能、電子メール等を用いて通知及び連絡を行うことがあります。
          </Description>
          <Description>
            ユーザーが弊社に通知、連絡又は問い合わせをする必要が生じた場合、本サービスのお問い合わせフォームを利用するものとし、電話や来訪を行うことはできないものとします。弊社は、かかる連絡又は問い合わせがあった場合、弊社が定める方法により、ユーザーの本人確認を行うことができるものとします。
          </Description>
          <Description>
            また、問合せに対する回答方法に関しては、弊社が適切と考える回答方法を利用することができるものとし、その回答方法をユーザーが決めることはできないものとします。
          </Description>
          <Description>2.譲渡禁止</Description>
          <Description>
            ユーザーは、弊社の書面による事前の承諾なく、本規約に基づく契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、貸与、その他の処分をすることはできません。
          </Description>
          <Description>3.事業譲渡</Description>
          <Description>
            弊社が本サービスに係る事業を第三者に譲渡する場合（事業譲渡、会社分割その他本サービスの主体が移転する一切の場合を含みます。）には、弊社は、当該事業の譲渡に伴い、ユーザーの本規約に基づく契約上の地位、本規約に基づく権利義務及びユーザー登録に伴い登録された情報その他の情報を当該事業の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき予め承諾するものとします。
          </Description>
          <Description>4.分離可能性</Description>
          <Description>
            本規約のいずれかの条項又はその一部が、法令等により無効と判断された場合であっても、当該無効とされた以外の部分は、継続して有効に存続するものとします。
          </Description>
          <Description>5.定めのない事項等</Description>
          <Description>
            本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、弊社及びユーザーは、信義誠実の原則に従って協議の上速やかに解決を図るものとします。
          </Description>
          <Description>6.言語</Description>
          <Description>
            本規約は、日本語を正文とします。本規約につき、参考のために英語による翻訳文が作成された場合でも、日本語の正文のみが契約としての効力を有するものとし、英訳はいかなる効力も有しないものとします。
          </Description>
          <Description>7.準拠法及び裁判管轄</Description>
          <Description>
            本規約は、日本法に基づき解釈されるものとし、ユーザーと弊社の間で生じた紛争については、その内容に応じて東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </Description>
        </Row>
        <Row>
          <Description>2021年7月24日制定</Description>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const Title = styled.div`
  text-align: center;
  margin: 40px 24px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`
const Row = styled.div``
const Header = styled.div`
  margin-bottom: 8px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface5};
`
const Description = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin-bottom: 8px;
`
const List = styled.ul`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const ListContainer = styled.li`
  list-style-type: lower-roman;
`
const NestListContainer = styled.li`
  list-style-type: lower-latin;
`
